export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8490.2b4f1c8c.jpg";